const mixin = {
    methods: {
      filter() {
            let filters = this.$store.state.filters;
            let list = [];
            for (const story of this.$store.state.storiesList) {
                let valid = true;
                for (const filter of filters) {
                if(['organization','author'].includes(filter.name) && !filter.children.includes(story[filter.name])) valid = false;
                if(filter.name == 'experience' && (!story.experience || story.experience && !filter.children.includes(story.experience.type))) valid = false;
                if(filter.name == 'starred' && !story.isStarred) valid = false;
                }
                if(valid) list.push(story)
            }
            return list;
      },

        remove(story){ this.$emit('deleteStory', story)},

        showActionList(actionIndex) {
            this.activeAction = this.activeAction == actionIndex ? null : actionIndex;
            this.$store.state.modelOpened = true;
        },

        toggleActions(cardIndex,story){
          this.isStarred = story.isStarred;
          if(this.activeAction == cardIndex) this.activeAction = null;
          else this.activeAction = cardIndex
          this.$store.state.modelOpened = this.activeAction != null ?  true : false;
        },

        deleteStory (story) {
          return (story) => {
            this.contextRightMenu = false
            this.$emit('deleteStory', story)
          }
        },
        downloadStory (story) {
          return (story) => {
            this.contextRightMenu = false
            this.$emit('downloadStory', story)
          }
        },
        editStoryInfo (story) {
          return (story) => {
            localStorage.setItem('storyId', story.id)
            this.contextRightMenu = false
            this.$emit('editStoryInfo', story)
          }
        
        },

        copyStory (story) {
            return (story) => {
              this.contextRightMenu = false
              this.$emit('copyStory', story)
            }
        
        },

        goDecisionTree (story) { 
        //  return (story) => { this.$router.push({name: 'storyEditView', params: {title: story.title}, query: {id: story.id}})}
          return (story) => {}
        },

        copyLink (story) {
          return (story) => { 
            this.contextRightMenu = false;
            this.contextRightMenu = false
            this.dialog = true
            this.getLink = true
            this.copyLinkAddress =
            location.host +
            '/storyEditView/' +
            story.title +
            '?' +
            'id' +
            '=' +
            story.id}
        },

        addToStarred (story) {
          this.isStarred = !this.isStarred
            return (story) =>{
              if(!story.isStarred) this.$emit('addToStarred', story);
              else this.$emit('removeFromStarred', story)
            }
        },

        removeFromStarred (story) {
          this.$emit('removeFromStarred', story)
        },

        copyUrl () {
          return (story) => {
            const copyText = document.getElementById('copyUrl')
            copyText.select()
            copyText.setSelectionRange(0, 99999)
            document.execCommand('copy')

          }
        },

        viewStoryDetail (story) {
          this.$emit('viewStoryDetail', story)
        },
        handler: function (e, index) {
          this.showActions = !this.showActions;
          console.log("actions-->",this.showActions);
          this.contextRightMenu = true
          this.optionsIndexVal = index
          e.preventDefault()
        },
        closeRightClick: function (e) {
          this.contextRightMenu = false;

        },
    },
}

export default mixin;


// WEBPACK FOOTER //
// ./src/mixins/GalleryListMixin.js